import { createContext, useRef, useState } from "react";

export const MapEventsContext = createContext();

export function MapEventsContextProvider({ children }) {
  const deckRef = useRef();
  const mapboxRef = useRef();
  const [mapEvents, setMapEvents] = useState({});

  return (
    <MapEventsContext.Provider
      value={{ mapEvents, setMapEvents, deckRef, mapboxRef }}
    >
      {children}
    </MapEventsContext.Provider>
  );
}
